import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataDisplayModalComponent } from "../../components/modal-templates/data-display-modal/data-display-modal.component";
import { DeleteConfirmationComponent } from "../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { EditorItemModalComponent } from "../../components/modal-templates/generic-modal/editor-item-modal.component";
import { SharedImports } from "../../components/shared.module";
import { devicesFields } from "../../core/dummy/dummy-data";
import { deviceTableColumns } from "../../core/table-templates/device-table";
import { MessageEnum } from "../../core/utils/message.enum";
import { BaseLayoutComponent } from "../base-layout.component";

@Component({
  selector: "app-devices-registry",
  standalone: true,
  imports: [CommonModule, SharedImports],
  templateUrl: "./devices-registry.component.html",
  styleUrl: "./devices-registry.component.scss",
})
export class DevicesRegistryComponent
  extends BaseLayoutComponent
  implements OnInit
{
  editingDevices: any;
  private modalService = inject(NgbModal);
  isLoading: boolean = false;
  selectedDeviceList: any = [];
  devices: any = [];
  options = {
    isExpandable: false,
  };

  iconSrc: string = "../../../../assets/images/agent/reclaim-agent-dark.svg";
  iconSrcDelete: string =
    "../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  columns = deviceTableColumns;
  localAgents: any;
  devicesFields: any;

  ngOnInit(): void {
    this.devicesFields = devicesFields;
    this.loadAgents();
    this.loadDevices();
  }

  loadDevices() {
    this.restService.getDevices(this.dataStore?.data?.id).subscribe((item) => {
      // Update deviceType based on simulator property
      this.devices = (item?.data || []).map((device: any) => ({
        ...device,
        deviceType: device.simulator ? 'Simulator' : 'EMULATOR',
      }));
      console.log("devices", this.devices);
    });
  }

  loadAgents() {
    this.isLoading = true;
    this.restService.getAgents(this.dataStore?.data?.id).subscribe(
      (response) => {
       
        const clusterAgents = response?.data
        .filter((agent: any) => agent?.type.toLowerCase() === 'cluster') 
        .map((agent: any) => ({
          value: agent.id,
          label: agent.name,
          icon:
            agent.status === "OFFLINE"
              ? "../../assets/images/agent/agent-dead.svg"
              : "../../assets/images/agent/agent-alive.svg",
        }));
        const localAgents = response?.data
        .filter((agent: any) => agent?.type.toLowerCase() === 'local')
        .map((agent: any) => ({
          value: agent.id,
          label: agent.name,
          icon:
            agent.status === "OFFLINE"
              ? "../../assets/images/agent/agent-dead.svg"
              : "../../assets/images/agent/agent-alive.svg",
        }));


        this.devicesFields = devicesFields.map((field) => {
          if (field.id === "agentId") {
            let options = [
              {
                label: "",
                options:  [
                  {
                    label: 'On Demand',
                    icon: "../../assets/images/agent/agent-alive.svg",
                    value: 'onDemand',
                    agentType: 'CLUSTER'
                  }
                ]
              },
              {
                label: "Local Execution Engines",
                options: localAgents,
              },
            ];
            return {
              ...field,
              fields: options,
            };
          } 
          if(field.id === "agentIdL") {
            let options = [
              {
                label: "Local Execution Engines",
                options: localAgents,
              },
            ];
            return {
              ...field,
              fields: options,
            };
          } 
          return field;
        });
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  openGenericModal(isEdit: boolean, rowData?: any) {
    this.editingDevices = rowData;
    var data = {
      displayName: isEdit ? "Update Device" : "Add New Device",
      saveBtnText: isEdit ? "Update" : "Add",
    };

    rowData = this.flattenKeys(rowData, ["credentials"]);
    const modalRef = this.modalService.open(EditorItemModalComponent, {
      centered: true,
      size: "lg",
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = {
      title: data.displayName,
      saveBtnText: data.saveBtnText,
      isEdit: isEdit,
      model: rowData,
    };
    this.devicesFields = this.devicesFields.map((field: any) => {
      if (!isEdit) {
        return { ...field, value: "" };
      }
    
      if (field.id === "agentId") {
        return { ...field, value: rowData?.[field.id] ?? "onDemand"};
      } else if (field.id === "agentIdL") {
        rowData.agentIdL =  rowData?.agentI;
        return { ...field, value: rowData?.agentId ?? "" };
      } else if (field.id === "configL") {
        rowData.configL =  rowData?.config;
        return { ...field, value: rowData?.config ?? "" };
      }else{
        return { ...field, value: rowData?.[field.id] ?? "" };
      }
    
    });
    
    modalRef.componentInstance.fields = this.devicesFields;
    modalRef.componentInstance.updateFormFields();
    modalRef.result.then((result) => {
      console.log("result", result);
      if (isEdit) {
        this.editDeviceValue(result, rowData?.id);
      } else {
        this.addDevice(result);
      }
    });
  }

  flattenKeys(obj: any, keysToFlatten: string[]): any {
    const result: any = {};
  
    for (const key in obj) {
      if (keysToFlatten.includes(key) && typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(result, obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  
    return result;
  }

  showDataList(rowData?: any) {
    const modalRef = this.modalService.open(DataDisplayModalComponent, {
      centered: true,
      size: "md",
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.mainFields = this.getExpandViewFields();
    modalRef.componentInstance.data = {
      ...rowData,
    };
    modalRef.componentInstance.configs = {
      title: `${rowData?.name} - Device Info`,
      isCustom: true
    };
    modalRef.result.then((result) => {});
  }

  openDeleteConfirmationModal() {
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass:"delete-confirmation-window",
      centered: true,
      size: "sm",
      backdrop: "static",
    });

    modalRef.result.then((result) => {
      if (result) {
        console.log(result, this.selectedDeviceList);
        this.deleteDevice();
      }
    });
  }

  deleteDevice() {
    let payload: any = [];
    this.selectedDeviceList.forEach((element: any) => {
      if (element?.id) {
        payload.push(element?.id);
      }
    });
    this.isLoading = true;
    this.restService.deleteDevices(this.dataStore?.data?.id, payload).subscribe(
      (item) => {
        if (item?.data?.deletedDeviceIds?.length) {
          this.devices = [
            ...this.devices.filter(
              (data: any) => !item?.data?.deletedDeviceIds.includes(data?.id)
            ),
          ];
          this.isLoading = false;
          this.toaster.pop({
            type: "success",
            text: MessageEnum.DEVICE_DELETE_SUCCESS,
          });
          this.selectedDeviceList = [];
        }
      },
      (error) => {
        this.isLoading = false;
        this.toaster.pop({
          type: "error",
          text: MessageEnum.DEVICE_DELETE_FAILURE,
        });
      }
    );
  }

  addDevice(result: any) {
    const payload = result?.value;
    this.isLoading = true;
    this.restService
      .addDevice(this.dataStore?.data?.id, this.getPayloadValues(payload))
      .subscribe(
        (item) => {
          if (item?.data) {
            item.data.deviceType = item?.data?.simulator ? 'Simulator' : 'EMULATOR';
            this.devices = [...this.devices, item?.data];
            this.isLoading = false;
            this.toaster.pop({
              type: "success",
              text: MessageEnum.DEVICE_CREATE_SUCCESS,
            });
          }
        },
        (error) => {
          this.isLoading = false;
          this.toaster.pop({
            type: "error",
            text: MessageEnum.DEVICE_CREATE_FAILURE,
          });
        }
      );
  }

  editDeviceValue(result: any, deviceId: string) {
    const payload = result?.value;
    this.isLoading = true;
    this.restService
      .editDevice(
        this.dataStore?.data?.id,
        deviceId,
        this.getPayloadValues(payload)
      )
      .subscribe(
        (item) => {
          item.data.deviceType = item?.data?.simulator ? 'Simulator' : 'EMULATOR';
          const index = this.devices.findIndex((d: any) => d.id === deviceId);
          if (index !== -1) {
            const updatedDevices = [...this.devices];
            updatedDevices[index] = { ...updatedDevices[index], ...item?.data };
            this.devices = updatedDevices;
          }
          this.isLoading = false;
          this.toaster.pop({
            type: "success",
            text: MessageEnum.DEVICE_UPDATE_SUCCESS,
          });
        },
        () => {
          this.isLoading = false;
          this.toaster.pop({
            type: "error",
            text: MessageEnum.DEVICE_UPDATE_FAILURE,
          });
        }
      );
  }

  getPayloadValues(payload: any) {
    payload.deviceType = "EMULATOR";
    if (payload.environment === "LOCAL") {
      payload.agentId = payload.agentIdL;
    } else {
      payload.agentId = payload?.agentId === "onDemand" ? null : payload?.agentId;
    }
    payload.config = payload.config ?? payload?.configL;
    delete payload.agentIdL;
    delete payload.configL;
    payload.automationPort = Number(payload?.automationPort);
    payload["isSimulator"] = payload?.simulator;
    payload["credentials"] = {
      username: payload?.username,
      accessKey: payload?.accessKey,
    };
   
    return payload;
  }

  handleActionsInTable(event: any) {
    if (event.type == "svg") {
      this.editDevice(event.data?.row);
    } else if (event.type == "link") {
      console.log(event);
      this.showDataList(event?.data?.row);
    }
  }

  editDevice(data: any) {
    this.openGenericModal(true, data);
  }

  handleRowSelect(event: any) {
    this.selectedDeviceList = event?.data;
  }

  changeIcon(isActive: boolean) {
    this.iconSrc = isActive
      ? "../../../../assets/images/agent/reclaim-agent-light.svg"
      : "../../../../assets/images/agent/reclaim-agent-dark.svg";
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? "../../../../assets/images/virtusa-icons/remove-icon-light.svg"
      : "../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  }

  getExpandViewFields() {
    return [
      {
        key: "name",
        name: "Device Name",
        type: "text-input",
      },
      {
        key: "serialNumber",
        name: "Serial Number",
        type: "text-input",
      },
      {
        key: 'deviceType',
        name: "Device Type",
        type: "text-input",
      },
       {
        key: 'platform',
        name: "Platform",
        type: "text-input",
      },
       {
        key: 'platformVersion',
        name: "Platform Version",
        type: "text-input",
      },
        {
        key: 'automationPort',
        name: "Automation Port",
        type: "text-input",
      },
       {
        key: 'environment',
        name: "Environment Type",
        type: "text-input",
      }
    ];
  }
}
